import { Contact, ContactInfo, Matter } from "@/lib/conflix";
import { TableCell, TableRow } from "./ui/table";
import { Button } from "./ui/button";
import { LoadingSpinner } from "./ui/loading-spinner";
import { ChevronRight, ChevronDown } from "lucide-react";
import axios from "axios";
import React, { useState } from "react";

const apiUrl = process.env.REACT_APP_API_URL;

const splitDate = (date: string) => {
    return date.split("T")[0];
}

function SimpleMatterRow(props: {
    matter: Matter;
    contact: Contact;
    designation: string;
    info?: ContactInfo;
    primaryContactInfoIds?: Record<string, string>;
    idToken: string;
}) {
    const [expanded, setExpanded] = useState<boolean>(false);
    const [loadedInfo, setLoadedInfo] = useState<ContactInfo | null>(null);
    const [loadingInfo, setLoadingInfo] = useState<boolean>(false);

    const hasContactInfo = props.primaryContactInfoIds &&
        Object.values(props.primaryContactInfoIds).some(v => v);

    const onToggleExpand = async () => {
        if (!expanded && !loadedInfo && hasContactInfo) {
            setLoadingInfo(true);
            try {
                const response = await axios.get(
                    `${apiUrl}matters/${props.matter.matterId}/contacts/${props.contact.contactId}/info`,
                    {
                        headers: {
                            Authorization: props.idToken,
                        },
                    }
                );
                setLoadedInfo(response.data);
            } catch (error) {
                console.error("Error fetching contact info:", error);
            }
            setLoadingInfo(false);
        }
        setExpanded(!expanded);
    };

    const effectiveInfo = loadedInfo || props.info;

    return (
        <>
        <TableRow className="hover:bg-gray-50">
            <TableCell className="w-8 p-1">
                {hasContactInfo && (
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={onToggleExpand}
                        disabled={loadingInfo}
                        className="h-6 w-6"
                    >
                        {loadingInfo ? (
                            <LoadingSpinner size={16} />
                        ) : expanded ? (
                            <ChevronDown className="h-4 w-4" />
                        ) : (
                            <ChevronRight className="h-4 w-4" />
                        )}
                    </Button>
                )}
            </TableCell>
            <TableCell>{props.matter.referenceNumber}</TableCell>
            <TableCell>{props.matter.name}</TableCell>
            <TableCell>{props.designation}</TableCell>
            <TableCell>{props.contact.firstName}</TableCell>
            <TableCell>{props.contact.lastName}</TableCell>
            <TableCell>{props.contact.middleName}</TableCell>
            <TableCell>{props.contact.companyName}</TableCell>
            <TableCell>{splitDate(props.contact.dateOfBirth)}</TableCell>
            <TableCell>{props.matter.status}</TableCell>
        </TableRow>
        {expanded && effectiveInfo && (
            <TableRow className="bg-gray-50">
                <TableCell />
                <TableCell colSpan={8} className="py-2">
                    <div className="flex gap-6 text-sm">
                        {effectiveInfo.phone && (
                            <div>
                                <span className="text-muted-foreground">Phone: </span>
                                {effectiveInfo.phone.value}
                            </div>
                        )}
                        {effectiveInfo.email && (
                            <div>
                                <span className="text-muted-foreground">Email: </span>
                                {effectiveInfo.email.value}
                            </div>
                        )}
                        {effectiveInfo.address && (
                            <div>
                                <span className="text-muted-foreground">Address: </span>
                                {effectiveInfo.address.value}
                            </div>
                        )}
                    </div>
                </TableCell>
                <TableCell />
            </TableRow>
        )}
        </>
    )
}

export default SimpleMatterRow;
